/**
 * Global workout completion event system.
 * Components subscribe to "workout-completed" events to refresh their data
 * immediately after a workout is saved.
 */

const EVENT_NAME = "workout-completed";

export function emitWorkoutCompleted() {
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function onWorkoutCompleted(callback: () => void): () => void {
  window.addEventListener(EVENT_NAME, callback);
  return () => window.removeEventListener(EVENT_NAME, callback);
}
